import { z } from 'zod';
import { UuidSchema, DateTimeSchema, NonEmptyStringSchema } from './common.schema';
import { UserSchema } from './user.schema';

// Group schemas
export const GroupSchema = z.object({
  id: UuidSchema,
  name: NonEmptyStringSchema,
  created_at: DateTimeSchema,
  owner: UuidSchema,
  pinned_categories: z.array(UuidSchema).nullable(),
});

export const GroupMembershipSchema = z.object({
  id: UuidSchema,
  group_id: UuidSchema,
  user_id: UuidSchema,
  joined_at: DateTimeSchema,
  left_at: DateTimeSchema.optional(),
});

export const InvitationSchema = z.object({
  id: UuidSchema,
  group_id: UuidSchema,
  created_at: DateTimeSchema,
  expires_at: DateTimeSchema,
  token: NonEmptyStringSchema,
  owner: UuidSchema,
});

export const GroupWithMembersSchema = GroupSchema.extend({
  joined_at: DateTimeSchema.optional(),  // API returns this for user's groups
  users: z.array(UserSchema).optional(),
  invitations: z.array(InvitationSchema).optional(),
});

// Request schemas
export const CreateGroupRequestSchema = z.object({
  name: NonEmptyStringSchema,
});

export const SetPinnedCategoriesRequestSchema = z.object({
  categories: z.array(UuidSchema),
});

// Response schemas
export const GroupsResponseSchema = z.object({
  groups: z.array(GroupWithMembersSchema),
});

export const UsersInGroupResponseSchema = z.object({
  users: z.array(UserSchema),
});

export const InvitationResponseSchema = z.object({
  invitation: InvitationSchema,
});

export const GroupResponseSchema = z.object({
  group: GroupSchema,
});

// Derived types
export type Group = z.infer<typeof GroupSchema>;
export type GroupMembership = z.infer<typeof GroupMembershipSchema>;
export type Invitation = z.infer<typeof InvitationSchema>;
export type GroupWithMembers = z.infer<typeof GroupWithMembersSchema>;
export type CreateGroupRequest = z.infer<typeof CreateGroupRequestSchema>;
export type SetPinnedCategoriesRequest = z.infer<typeof SetPinnedCategoriesRequestSchema>;
export type GroupsResponse = z.infer<typeof GroupsResponseSchema>;
export type UsersInGroupResponse = z.infer<typeof UsersInGroupResponseSchema>;
export type InvitationResponse = z.infer<typeof InvitationResponseSchema>;
export type GroupResponse = z.infer<typeof GroupResponseSchema>;

// Re-export User type from user schema
export type { User } from './user.schema';